export const SET_SIZE = 'SET_SIZE'
export const SET_HEIGHT = 'SET_HEIGHT'
export const SET_ORIENTATION = 'SET_ORIENTATION'
